import { Checkbox } from '@mui/material';
import React from 'react';

interface IProps {
  disabled?: boolean;
  containsUserPhoto?: boolean;
  setContainsUserPhoto: (containsUserPhoto: boolean) => void;
}

export const TemporaryLicenseCheckBox = ({
  disabled = false,
  containsUserPhoto = true,
  setContainsUserPhoto,
}: IProps) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Checkbox
        name="isTemporaryLicense"
        disabled={disabled}
        checked={!containsUserPhoto}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setContainsUserPhoto(!event.target.checked);
        }}
        sx={{
          '& .MuiSvgIcon-root': { fontSize: 21 },
          '&': { padding: '5px 5px 5px 0px' },
        }}
      />
      <div
        style={{
          textAlign: 'left',
          paddingTop: '18px',
        }}
      >
        This is a temporary license <b>without</b> a photo
      </div>
    </div>
  );
};
